import React, { useState, useCallback } from "react";
import { Button, message } from "antd";
import { DownloadOutlined } from "@ant-design/icons";
import { downloadExport } from "../../../utils/exportDownload";

interface WizardExportButtonProps {
  stage: number;
  orgId: string | null;
  disabled?: boolean;
  buttonStyle?: React.CSSProperties;
  buttonClassName?: string;
}

function WizardExportButton({
  stage,
  orgId,
  disabled = false,
  buttonStyle = undefined,
  buttonClassName = undefined,
}: WizardExportButtonProps) {
  const [loading, setLoading] = useState(false);

  const handleExport = useCallback(async () => {
    if (!orgId) return;
    setLoading(true);
    try {
      await downloadExport({
        orgId,
        stage,
        includeDeps: true,
      });
      message.success("Export downloaded successfully");
    } catch (err) {
      const errorMessage = err instanceof Error ? err.message : "Export failed";
      message.error(errorMessage);
    } finally {
      setLoading(false);
    }
  }, [orgId, stage]);

  return (
    <Button
      size="large"
      type="primary"
      onClick={handleExport}
      disabled={!orgId || disabled}
      loading={loading}
      icon={<DownloadOutlined />}
      style={buttonStyle}
      className={buttonClassName}
    >
      Export (LNX)
    </Button>
  );
}

export default WizardExportButton;
